module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-nissan.9b7629fd.png";